var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.68 65.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.18 47.89a16.49 16.49 0 0 1-33 0C24.2 45.43 18.39 36 18.39 36s9 2 10.22.72a16.49 16.49 0 0 1 28.57 11.17m-24.85 2.9h16.49m-16.49-6.36h16.49",
    "data-name": "Layer 74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 16.86a7.7 7.7 0 0 0 2.08.67 7.3 7.3 0 0 0 1.4.12h0A8.16 8.16 0 0 0 28 12a7.8 7.8 0 0 0 .34-2.4 8.06 8.06 0 0 0-16.12 0 9 9 0 0 0 .33 2.4 8.1 8.1 0 0 0 4.25 4.86m21.01 12.73a10.51 10.51 0 0 0-9.18-5.65H11.76A10.26 10.26 0 0 0 1.8 32c-.19.78-.3 23.16-.3 23.16l22.33.07",
    "data-name": "Layer 28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnRequest);
export default __webpack_public_path__ + "static/media/onRequest.4e9239e7207b15d039aac60215b5a2c3.svg";
export { ForwardRef as ReactComponent };